
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifestyle",
      function () {
        return require("private-next-pages/lifestyle.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifestyle"])
      });
    }
  